import { PowerSyncDatabase, WASQLiteVFS } from "@powersync/web"
import { AppSchema } from "./schema"

export const powerSyncDb = new PowerSyncDatabase({
  schema: AppSchema,
  database: {
    dbFilename: "fieldbook-powersync.db",
    vfs: WASQLiteVFS.OPFSCoopSyncVFS,
    // enableMultiTabs is deliberately left to the SDK. Its default also
    // excludes iOS, Android and Safari, where shared workers are present but
    // do not work: multi-tab runs the whole sync client (transport included)
    // in a SharedWorker, and in the iOS WebView that worker never comes up,
    // so connect() hangs with no error and no request.
  },
})
